export const normalizePublicationQuantityInput = (value) =>
  String(value ?? "").replace(/[^0-9]/g, "");

export const isValidPublicationQuantity = (value) =>
  /^[1-9][0-9]*$/.test(String(value ?? ""));

export const parsePublicationQuantity = (value) => Number(value);
